import { render, staticRenderFns } from "./Domiciliary.vue?vue&type=template&id=63d60337&"
import script from "./Domiciliary.vue?vue&type=script&lang=js&"
export * from "./Domiciliary.vue?vue&type=script&lang=js&"
import style0 from "./Domiciliary.vue?vue&type=style&index=0&id=63d60337&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports